export default __webpack_public_path__ + "static/media/RPDbanner.1c451fa9.png";